import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import './Quize.css'
const Quize = ({ quize }) => {
    const { id, name, logo, total } = quize;
    return (
        <div className="col-sm-6 position-relative">
            <div className="card inner-box">
                <div className="pattern-layer"></div>
                <div className="card-body content">
                    <img src={logo} className='w-100' alt="" />
                    <div className='d-flex justify-content-between align-items-center mt-3'>
                        <p className='text-primary fw-bold'>{name}</p>
                        <p>Quizzes: {total}</p>
                    </div>
                    <div className='text-center'>
                        <Link className='my-btn btn btn-primary' to={`/quizzes/${id}`}>
                            Start Quize <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Quize;